import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ontos-code" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_view_info = _resolveComponent("ontos-view-info")!
  const _component_ontos_info_row = _resolveComponent("ontos-info-row")!
  const _component_ontos_state_list = _resolveComponent("ontos-state-list")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      (_ctx.loaded && _ctx.workflow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ontos_page_header, _normalizeProps(_guardReactiveProps(_ctx.heading)), {
              actions: _withCtx(() => [
                (_ctx.can('designer'))
                  ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                      key: 0,
                      icon: "mdi-pencil",
                      label: _ctx.$tt('edit'),
                      to: {name: 'edit-workflow', params: _ctx.$route.params}
                    }, null, 8, ["label", "to"]))
                  : _createCommentVNode("", true),
                (_ctx.can('designer'))
                  ? (_openBlock(), _createBlock(_component_ontos_header_action, {
                      key: 1,
                      icon: "mdi-delete",
                      label: _ctx.$tt('delete'),
                      color: "error",
                      onClick: _ctx.deleteThis
                    }, null, 8, ["label", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 16),
            _createVNode(_component_ontos_info_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ontos_view_info, {
                  title: _ctx.$tt('workflow-name')
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.workflow.name), 1)
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_ontos_view_info, {
                  title: _ctx.$tt('alias')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.workflow.alias), 1)
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              _: 1
            }),
            _createVNode(_component_ontos_state_list, {
              states: _ctx.workflow.states,
              title: _ctx.$tt('states'),
              dense: ""
            }, null, 8, ["states", "title"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}